class PlSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-pl-track]');
    this.prev = this.querySelector('[data-pl-prev]');
    this.next = this.querySelector('[data-pl-next]');
    if (!this.track) return;
    this.onScroll = this.update.bind(this);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
    if (this.next) this.next.addEventListener('click', () => this.step(1));
    this.update();
  }

  disconnectedCallback() {
    if (this.track) this.track.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  step(dir) {
    const item = this.track.querySelector('[data-pl-item]');
    const width = item ? item.getBoundingClientRect().width : this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap || 0) || 0;
    this.track.scrollBy({ left: dir * (width + gap), behavior: 'smooth' });
  }

  update() {
    if (!this.track) return;
    const max = this.track.scrollWidth - this.track.clientWidth - 2;
    if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
    if (this.next) this.next.disabled = this.track.scrollLeft >= max;
  }
}

if (!customElements.get('pl-slider')) customElements.define('pl-slider', PlSlider);

class PlHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-pl-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-pl-dot]'));
    this.index = 0;
    if (this.slides.length < 2) return;
    this.interval = parseInt(this.dataset.autoplay || '0', 10);
    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.goTo(i);
        this.restart();
      });
    });
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  goTo(i) {
    this.index = (i + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, n) => slide.classList.toggle('is-active', n === this.index));
    this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === this.index ? 'true' : 'false'));
  }

  start() {
    if (!this.interval) return;
    this.stop();
    this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
  }

  restart() {
    this.stop();
    this.start();
  }
}

if (!customElements.get('pl-hero')) customElements.define('pl-hero', PlHero);
